<template>
  <div class="py-4 container-fluid" style="margin-top:-10px">
    <div class=" row">
      <div class="col-8">
        <card title="Influencer : " :value="this.influ_name">
        
        </card>
      </div>
      <div class="col-4">
        <card
          title="Points"
          :value="total_points"
        ></card>
      </div>
    </div>
    <div class=" row" style="margin-top:-10px">
      <div class="col-4">
        <card
          title="T-1 Members"
          :value="tier_1_members"
        ></card>
      </div>
      <div class="col-4" v-show="is_extra">
        <card
          title="Total Members"
          :value="all_members"
        ></card>
      </div>

      <div class="col-4">
        <card
          title="Total Exchange"
          :value="total_exchange + '.00'"
        ></card>
      </div>
        <!-- <card
          title="TEST"
          value="10"
          percentage="10"
          iconClass="ni ni-money-coinss"
          iconBackground="bg-gradient-primary"
          detail="Detail naja"
          directionReverse
        ></card> -->

    </div>
    <div class=" row">
      <div class="col-12">
        <referrers-table-extra />
      </div>
    </div>
  </div>
</template>



<script>
/* eslint-disable */
// import AuthorsTable from "./components/AuthorsTable.vue";
import ReferrersTableExtra from "./components/ReferrersTableExtra.vue";
import Card from "@/examples/Cards/Card.vue";
import axios from 'axios'
const qs = require('querystring')

var host_api=window.localStorage.getItem('$host_api');

export default {
  name: "referral-extra",
  components: {
    ReferrersTableExtra,
    Card,
  },
  data() {
    return {
      influencer_id : "",
      influ_name : "",
      tier_1_members : 0,
      all_members : 0,
      total_points : 0,
      total_exchange : 0,
      members : [],
      is_extra : false

    };
  },
  mounted () {
    var user = window.localStorage.getItem('$logged_user');
    if (user != 'extra' && user != 'admin')
      this.$router.push('/')

    var influ = this.$store.state.user;
    if (this.$store.state.type == 'extra')
      this.is_extra = true
    else 
      this.is_extra = false

    this.influ_name = influ.line_display
    this.total_points = influ.point
    this.tier_1_members = this.$store.state.memo.length
    this.all_members = this.count_all_member(this.$store.state.memo)

    // host_api=window.localStorage.getItem('$host_api');
    // const config = {
    //   headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded'
    //   }
    // }
    // const requestBody = {
    //     username: 'Ufc4d40fd780b28e64f5c25c706e54c92',
    // }
    // axios.post(host_api+"/admin/users/extra", qs.stringify(requestBody), config,
    // ).then(response => {
    //   this.influ_name = response.data.user.line_display
    //   this.tier_1_members = response.data.t1.length
    //   this.total_points = response.data.user.point
    //   this.members = response.data.t1
    //   this.all_members = this.count_all_member(response.data.t1);
    // })


  },
  methods : {
    count_all_member(members) {
      var all = 0
      var t1 = members.length;
      var t2 = 0
      var t3 = 0
      // console.log(members.length)
      members.forEach(member => {
        if (member.t2.length > 0) {
          t2 = t2 + member.t2.length
          member.t2.forEach(t2 => {
            if (t2.t3.length >0 )
              t3 = t3 + t2.t3.length
          });
        }
      });
      all = t1 + t2 + t3

      return all

    },
  }

};
</script>
